import { render } from "./BoardTopPage.vue?vue&type=template&id=0f63c13d"
import script from "./BoardTopPage.vue?vue&type=script&lang=js"
export * from "./BoardTopPage.vue?vue&type=script&lang=js"
script.render = render

export default script